
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Tabs from "./../../components/generic/tabs.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import Tab from "@/interfaces/Tab";
import {
  mdiStore,
} from "@mdi/js";

@Component({
  components: { Tabs, SvgIcon, mdiStore },
})
export default class OptionsPage extends Vue {

  get headers() {
    return this.resourceList ? this.initHeaders.concat(this.resourceList
      .map((r) => ({
          id: r.id,
          text: r.name,
          icon : this.computeIconForResource(r),
          value: "label",
          width: "50px",
          sortable: false,
          groupable: true,
        }),
      )) : this.initHeaders;
  }

  get optionTypesByCurrentResourceType() {
    return this.optionTypes.filter((type) => type.resourceType === this.tab);
  }

  public optionTypes: any[] = [];
  public resourceList: any[] = [];
  public resourceCount: number = 0;
  public options: any = {
    BUILDING: {},
    RELAY: {},
  };
  public loading: boolean = false;
  public initHeaders = [
    {
      text: "",
      value: "label",
      width: "50px",
      sortable: false,
      groupable: false,
    },
  ];
  private ITEM_PER_PAGE: number = 10;

  @Getter private envCompany: any;
  @Getter private currentUser: any;
  @Getter private canDoInEnvCompany: (right: string) => boolean;

  private tabs: Tab[] = [{ label: "RELAY", tradKey: "options.title.relays" }];
  private tab: string = "RELAY";
  private page: number = 1;
  private resourceHelper = {
    RELAY: {
      storeFn: "companies/getRelays",
      storeFnCallback(res) {
        this.resourceList = res.rows;
        this.resourceCount = res.count;
      },
      query: {
        query: {
        itemsPerPage: this.ITEM_PER_PAGE,
        },
      },
    },
    BUILDING: {
      storeFn: "companies/getCompanyBuildingList",
      pagination: true,
      storeFnCallback(res) {
        this.resourceList = res.rows;
        this.resourceCount = res.count;
      },
      query: {
        page: 1,
        itemsPerPage: this.ITEM_PER_PAGE,
      },
    },
  };

  public async mounted() {
    if (this.canDoInEnvCompany("READ_BUILDING")) {
      this.tabs.push({ label: "BUILDING", tradKey: "options.title.building" });
    }
    this.loading = true;
    this.optionTypes = await this.$store.dispatch("options/readType");
    await this.selectTab({ label: "RELAY" });
  }

  public async selectTab(eventTab: Tab) {
    this.tab = eventTab.label;
    await this.fetchResource(this.resourceHelper[this.tab]);
  }

  public updatePagination(page) {
    this.resourceHelper[this.tab].query.page = page;
    this.fetchResource(this.resourceHelper[this.tab]);
  }

  public async fetchResource(resourceHelper) {
    await this.$store.dispatch(resourceHelper.storeFn, { companyId: this.envCompany.id, ...resourceHelper.query })
      .then(this.resourceHelper[this.tab].storeFnCallback.bind(this) || ((r) => r))
      .then(async () => {
        for (const index in this.resourceList) {
          if (this.resourceList.hasOwnProperty(index)) {
            await this.$store.dispatch("options/readOptionsByResource", {
              resourceType: this.tab.toLowerCase(),
              resourceId: this.resourceList[index].id,
              optionTypeLabelList: this.optionTypes
                .filter((type) => type.resourceType === this.tab)
                .map((type) => type.label),
            }).then((res) => {
              this.$set(this.options[this.tab], this.resourceList[index].id, res);
            });
          }
        }
        this.loading = false;
      });
  }

  private async onChangeCell(resourceId, optionTypeLabel, value) {
    this.loading = true;
    await this.$store.dispatch("options/updateByResourceId", {
      resourceType: this.tab.toLowerCase(),
      resourceId,
      optionTypeLabel,
      value,
    }).then((res) => {
      this.loading = false;
    });

  }

  private computeIconForResource(r) {
    if (this.tab !== "BUILDING") {
      return null;
    }
    return r.Relays?.length > 0 ? mdiStore : null;
  }
}
